<mat-toolbar color="primary">
    <span>Prescription</span>
    <span class="toolbar-spacer"></span>
    <button *ngIf="prescription.id !== 0" mat-icon-button style="margin-top: 9px;">
        <fa-icon (click)="save()" [icon]="['fas','save']" size="2x"></fa-icon>
    </button>
</mat-toolbar>
<div fxLayout="row">
    <div fxFlex="50%">
        <app-prescription-side (entryAdded)="addEntry($event)"></app-prescription-side>
    </div>
    <div fxFlex="50%">
        <app-prescription [prescription]="prescription"></app-prescription>
    </div>
</div>
